import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase'; // Adjust the import according to your project structure

const Login: React.FC<{
  onLoginSuccess: () => void;
  onSignUpClick: () => void;
  onForgotPasswordClick: () => void;
}> = ({ onLoginSuccess, onSignUpClick, onForgotPasswordClick }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async () => {
    try {
      setError(null);
      await signInWithEmailAndPassword(auth, email, password);
      onLoginSuccess(); // Navigate to daily view
    } catch (err: any) {
      if (err.code === 'auth/invalid-email') {
        setError('Invalid email. Please try again.');
      } else if (err.code === 'auth/invalid-credential') {
        setError('Incorrect password. Please try again.');
      } else {
        setError(err.message);
      }
    }
  };

  return (
    <div className='flex justify-center items-center h-screen bg-gradient-to-r from-blue-500 to-blue-700'>
      <div className='p-6 max-w-md bg-white rounded-lg shadow-lg'>
        <h2 className='text-xl font-bold text-center text-blue-700 mb-4'>
          Log In
        </h2>
        {error && <p className='text-red-500 text-sm mb-4'>{error}</p>}
        <input
          type='email'
          placeholder='Email'
          className='block w-full p-2 mb-4 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type='password'
          placeholder='Password'
          className='block w-full p-2 mb-4 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          onClick={handleLogin}
          className='block w-full bg-blue-700 text-white p-2 rounded hover:bg-blue-800'
        >
          Log In
        </button>
        <p className='text-center mt-6'>
          Don't have an account?{' '}
          <button onClick={onSignUpClick} className='text-blue-500 underline'>
            Sign up
          </button>
        </p>
        <button
        onClick={onForgotPasswordClick}
        type="button"
        className="mt-2 text-sm text-blue-600 hover:text-blue-800 underline cursor-pointer"
      >
        Forgot Password?
      </button>
      </div>
    </div>
  );
};

export default Login;
